import { render, staticRenderFns } from "./TransportAllocation.vue?vue&type=template&id=65eaea23"
import script from "./TransportAllocation.vue?vue&type=script&lang=js"
export * from "./TransportAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports